import React, { useState, useEffect } from 'react';
import Switch from 'react-switch';

interface ToggleSwitchProps {
  index?: number | string;
  value: boolean;
  onToggleChange: (params: { value: boolean; data: string | number }) => void;
  onValue?: string | null | boolean;
  offValue?: string | null | boolean;
  showingValue?: boolean;
  disabled?: boolean;
  height?: number;
  width?: number;
  handleDiameter?: number;
  offHandleColor?: string;
  offColor?: string;
  id?: string;
  dataTestId?: string;
}

const ToggleSwitch = ({
  index,
  value,
  onToggleChange,
  onValue = null,
  offValue = null,
  showingValue = false,
  disabled = false,
  height = 15,
  width = 31,
  handleDiameter = 21,
  offHandleColor = '#7B7979',
  offColor = '#E9E9E9',
  id,
  dataTestId,
}: ToggleSwitchProps) => {
  const [isChecked, setIsChecked] = useState(value);

  useEffect(() => {
    setIsChecked(value);
  }, [value]);

  const handleToggle = () => {
    if (disabled) return null;

    const newValue = !isChecked;
    onToggleChange({ value: newValue, data: index });
  };

  return (
    <div data-testid={dataTestId} className="flex items-center gap-x-2">
      <Switch
        offColor={offColor}
        checked={isChecked}
        checkedIcon={false}
        uncheckedIcon={false}
        height={height}
        offHandleColor={disabled ? '#D3D2D2' : offHandleColor}
        width={width}
        handleDiameter={handleDiameter}
        onColor="#F3C5C7"
        onHandleColor="#CE181E"
        onChange={handleToggle}
        disabled={disabled}
        id={id}
      />

      {showingValue && (
        <p className="text-[#666666] text-sm font-medium">{isChecked ? onValue : offValue}</p>
      )}
    </div>
  );
};

export default ToggleSwitch;
